import React from 'react';

function Contact() {
  return (
    <div className="slds-grid slds-gutters">
      <div className="slds-col slds-size_1-of-1">
        <div className="slds-card">
          <div className="slds-card__body slds-card__body_inner">
            <h1 className="slds-text-heading_large slds-p-bottom_medium">Contact Us</h1>
            
            <div className="slds-grid slds-gutters slds-p-bottom_medium">
              <div className="slds-col slds-size_1-of-2">
                <div className="slds-card">
                  <div className="slds-card__body slds-card__body_inner">
                    <h2 className="slds-text-heading_medium slds-p-bottom_small">Contact Information</h2>
                    <div className="slds-p-bottom_medium">
                      <p className="slds-text-body_regular">
                        <strong>Email:</strong><br />
                        <a href="mailto:EricaLayer@peakautismcenter.com">EricaLayer@peakautismcenter.com</a><br />
                        <a href="mailto:DrewFry@peakautismcenter.com">DrewFry@peakautismcenter.com</a>
                      </p>
                      <p className="slds-text-body_regular">
                        <strong>Phone:</strong><br />
                        <a href="tel:810-937-5012">(810) 937-5012</a>
                      </p>
                      <p className="slds-text-body_regular">
                        <strong>Fax:</strong><br />
                        (844) 205-9989
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="slds-col slds-size_1-of-2">
                <div className="slds-card">
                  <div className="slds-card__body slds-card__body_inner">
                    <h2 className="slds-text-heading_medium slds-p-bottom_small">Hours of Operation</h2>
                    <p className="slds-text-body_regular">
                      Monday - Friday: 8:00 AM - 6:30 PM<br />
                      Saturday - Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            
            <div className="slds-grid slds-gutters slds-p-bottom_medium">
              <div className="slds-col slds-size_1-of-2">
                <div className="slds-card">
                  <div className="slds-card__body slds-card__body_inner">
                    <h2 className="slds-text-heading_medium slds-p-bottom_small">Detroit Location</h2>
                    <p className="slds-text-body_regular slds-p-bottom_small">
                      18101 E. Warren Avenue<br />
                      Detroit, MI 48224
                    </p>
                    <div style={{ height: '300px', width: '100%', marginTop: '0.5rem' }}>
                      <iframe
                        title="Detroit Location"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ border: 0 }}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2950.8999999999996!2d-82.9167!3d42.4167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824d2c8c3c3c3c3%3A0x3c3c3c3c3c3c3c3c!2s18101%20E%20Warren%20Ave%2C%20Detroit%2C%20MI%2048224!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
                        allowFullScreen
                      />
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="slds-col slds-size_1-of-2">
                <div className="slds-card">
                  <div className="slds-card__body slds-card__body_inner">
                    <h2 className="slds-text-heading_medium slds-p-bottom_small">Port Huron Location</h2>
                    <p className="slds-text-body_regular slds-p-bottom_small">
                    3071 Commerce Drive<br />
                    Fort Gratiot, MI 48059
                    </p>
                    <div style={{ height: '300px', width: '100%', marginTop: '0.5rem' }}>
                      <iframe
                        title="Port Huron Location"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ border: 0 }}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2916.236916793076!2d-82.4618854236166!3d43.03644649210155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88259bceca0ef0fd%3A0x7b00e4faa16bc2e5!2s3071%20Commerce%20Dr%2C%20Fort%20Gratiot%20Township%2C%20MI%2048059!5e0!3m2!1sen!2sus!4v1752689396927!5m2!1sen!2sus"
                        allowFullScreen
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact; 